interface BoundaryCheck {
  hit(): boolean;
}

abstract class BoundaryCheckBase implements BoundaryCheck {
  public get parent(): DOMRect {
    return this._parent;
  }

  public get child(): DOMRect {
    return this._child;
  }

  constructor(
    private readonly _parent: DOMRect,
    private readonly _child: DOMRect
  ) {}

  public abstract hit(): boolean;
}

class StrictBoundaryCheck extends BoundaryCheckBase {
  public hit(): boolean {
    return (
      this.child.top >= this.parent.top &&
      this.child.left >= this.parent.left &&
      this.child.bottom <= this.parent.bottom &&
      this.child.right <= this.parent.right
    );
  }
}

class HorizontalBoundaryCheck extends BoundaryCheckBase {
  public hit(): boolean {
    return (
      this.child.left >= this.parent.left &&
      this.child.right <= this.parent.right
    );
  }
}

class VerticalBoundaryCheck extends BoundaryCheckBase {
  public hit(): boolean {
    return (
      this.child.top >= this.parent.top &&
      this.child.bottom <= this.parent.bottom
    );
  }
}

export type BoundaryCheckType = 'strict' | 'horizontal' | 'vertical';

export class Boundaries {
  constructor(
    private readonly _parent: DOMRect,
    private readonly _child: DOMRect,
    private readonly _type: BoundaryCheckType = 'strict'
  ) {}

  public inside(): boolean {
    return this._check();
  }

  public outside(): boolean {
    return !this._check();
  }

  public _check(): boolean {
    return this._boundary().hit();
  }

  private _boundary(): BoundaryCheck {
    switch (this._type) {
      case 'strict':
        return new StrictBoundaryCheck(this._parent, this._child);
      case 'horizontal':
        return new HorizontalBoundaryCheck(this._parent, this._child);
      case 'vertical':
        return new VerticalBoundaryCheck(this._parent, this._child);
    }
  }
}
